<template lang="pug">
  span.wrap
    | {{ label }}
    el-tooltip(placement="top" popper-class="foo")
      fa-icon.tooltip-icon(icon="info-circle" size="xs")
      .ethos-tooltip.tooltip-content(slot="content")
        slot

</template>

<script>
export default {
  props: {
    label: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
:global(.el-tooltip__popper) {
  max-width: 250px;
}

.wrap {
  display: inline-flex;
  align-items: center;
}

.tooltip-icon {
  margin-left: 5px;
}

.tooltip-content {
  :global(p) {
    margin: 10px 0 !important;
  }
}

:global(.tooltip-wrap) {
  padding: 10px;
}
</style>
